import { coreOnboardingProgressName } from './name';
import { getOnboardingProgress } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreOnboardingProgressGetAsyncSlice = createGetAsyncSlice({
	name: coreOnboardingProgressName,
	receive: true,
	request: false,
	requestHandler: getOnboardingProgress,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
